// src/stage2/props/GateDoor.jsx
import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';

const GATE_URL = '/stageAssets/stage2/scene/Stage2Exterior-GateDoor.glb';

export function GateDoor(props) {
  const group = useRef();
  const { scene } = useGLTF(GATE_URL);

  return (
    <group ref={group} {...props}>
      <primitive object={scene} />
    </group>
  );
}

useGLTF.preload(GATE_URL);
